export class FormsCreatedApiModel {
  public Forms: FormsCreatedItem[];

  public deserialize(data): FormsCreatedApiModel {
    const valueExists = data.Forms.some((formItem) => !!formItem.Value);

    if (!valueExists) {
      this.Forms = [];
    } else {
      this.Forms = data.Forms.map((formData: FormsCreatedItem) => {
        --formData.Month;
        return formData;
      });
    }

    return this;
  }
}

export class FormsCreatedItem {
  Month: number;
  Value: number;
  Year: number;
}
